import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import JwtService from "@/helpers/authservice/jwt.service";
const timeout = 800000
/**
 * Service to call HTTP request via Axios
 */
const ApiMsMaterialsService = {
  init() {
    Vue.use(VueAxios, axios)
    Vue.axios.defaults.baseURL = process.env.VUE_APP_MS_MATERIALS_URL
  },

  /**
   * Send the GET HTTP request
   * @param resource
   * @param params
   * @returns {*}
   */
  async get(resource, params = {}, responseType = undefined) {
    this.init()
    return await Vue.axios.get(`${resource}`, {
      params,
      timeout: timeout,
      responseType: responseType,
      headers: {
        'Authorization': `Bearer ${JwtService.getToken()}`
      }
    })
  },

  /**
   * Set the POST HTTP request
   * @param resource
   * @param params
   * @returns {*}
   */
  async post(resource, params) {
    this.init()
    return await Vue.axios.post(`${resource}`, params, {
      timeout: timeout,
      headers: {
        'Authorization': `Bearer ${JwtService.getToken()}`
      }
    })
  },

  /**
   * Send the PUT HTTP request
   * @param resource
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  async put(resource, params) {
    this.init()
    return Vue.axios.put(`${resource}`, params, {
      timeout: timeout,
      headers: {
        'Authorization': `Bearer ${JwtService.getToken()}`
      }
    })
  },

  /**
   * Send the DELETE HTTP request
   * @param resource
   * @returns {*}
   */
  async delete(resource, payload = {}) {
    this.init()
    return await Vue.axios.delete(resource, {
      data: payload,
      timeout: timeout,
      headers: {
        'Authorization': `Bearer ${JwtService.getToken()}`
      }
    })
  }
}

export default ApiMsMaterialsService
